import { Component, OnInit,ViewChild } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import swal from 'sweetalert2';  
import { Router } from '@angular/router';


@Component({
  selector: 'app-lista-cliente',
  templateUrl: './lista-cliente.component.html',
  styleUrls: ['./lista-cliente.component.scss']
})
export class ListaClienteComponent implements OnInit {

  constructor(public authService: AuthService,public router:Router) { }
  bndmenu;
  id_usuario;
  @ViewChild('clochart',null) clochart;
  @ViewChild('clochart1',null) clochart1;
  facturas;
  bndcli=false;
  ngOnInit() {
    if(!localStorage.getItem('garoce')){      
      this.router.navigate(['/login']);
    }
    if(Number(localStorage.getItem("cliente"))==1){
      this.bndmenu=false;
    }else{
      this.bndmenu=true;
    }
    if(localStorage.getItem("garoce")=="1"){
      this.bndcli=true;
    }else{
      this.bndcli=false;
    }
    this.id_usuario=localStorage.getItem("usuario");
    try {
      this.facturas=localStorage.getItem("facturas");  
    } catch (error) {
      this.facturas=0;
      
    }
    this.ls_cliente_preventa();
    this.ls_prospectos()
  }
  cerrarsesion(){
    this.router.navigate(["/"]);
  }
  ncliente_(){
this.rznombre=""
  }
  v_clientes(t){
    switch (t) {
      case 'C':
        this.preventas=this.clientes;
      break;
      case 'L':
        this.preventas=this.prospectos;
          break;
      case 'G':
        this.preventas=this.garoce;
          break;
      default:
        break;
    }

  }
  rznombre=""
  tipo_reg="L"
  gda_cliente(){
      	if(this.rznombre=="")return;
      let postData={       
        razonsocial:this.rznombre,
        estatus:this.tipo_reg
      };
      //console.log(postData)
      this.authService.service("/api/gda_cliente_nombre",postData)
      .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            
            let postDatapms={
              id_usuario:localStorage.getItem("usuario"),
              id_cliente:res.insertId
            }
            //console.log
            this.authService.service("/api/gda_pms",postDatapms)
            .then(
              data => {
                var itm;
                 /* localStorage.setItem("id_cliente",res.insertId); 
                  localStorage.setItem("nom_cliente",this.rznombre); 
                  localStorage.setItem("cliente",res.insertId);
                  localStorage.setItem("cliente_","");
                  localStorage.setItem("modulos",""); 
                  this.router.navigate(['/editacliente']); */
                  
                  this.clochart1.nativeElement.click();
                  if(this.tipo_reg=='C')this.ls_cliente_preventa();                  
                  if(this.tipo_reg=='L')this.ls_prospectos()

                  swal.fire({ icon: "success", html: "<h3>Información registrada</h3><h5>Finalizando, favor espere...</h5>", showConfirmButton: false, timer: 1000 });

              },
              error => {
                console.log(error.message)
                  var de= JSON.stringify(error);
                  var di = JSON.parse(de)
                  swal.fire('¡API incorrecta! PMS ', '', 'error');
              });   
          }           
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! ', '', 'error');
        });   
   
  }
  edt_responsable(){
    for(var i=0;i<this.responsables.length;i++){
      if(this.responsables[i].id==this.responsable.id){
        this.responsables[i].nombre=this.responsable.nombre;
        this.responsables[i].paterno=this.responsable.paterno;
        this.responsables[i].materno=this.responsable.materno;
        this.responsables[i].proveedor=this.responsable.proveedor;
        this.responsables[i].cargo=this.responsable.cargo;
        this.responsables[i].rs=this.responsable.rs;
        this.responsables[i].rfc=this.responsable.rfc;
        this.responsables[i].correo=this.responsable.correo;
        this.responsables[i].tel1=this.responsable.tel1;
        this.responsables[i].ext1=this.responsable.ext1;
        this.responsables[i].direccion=this.responsable.direccion;
      }
    }
  }
  public URL:any;
  fileToUpload: File = null;
  onSelectFile(event,idx) {
    //console.log(event);
    this.URL = event.target.files;
    this.fileToUpload = event.target.files[0];
  }
  img=""
  txt_fot=""
  bndEdtRs=true;
  responsables=[];
  edit_resp(itm){
    this.responsable={
      id:itm.id,
      nombre:itm.nombre,
      proveedor:itm.proveedor,
      paterno:itm.paterno,
      materno:itm.materno,
      cargo:itm.cargo,
      rs:itm.rs,
      rfc:itm.rfc,
      correo:itm.correo,
      tel1:itm.tel1,
      ext1:itm.ext1,
      direccion:itm.direccion 
    };
    this.bndResponsable=true;
  }
  eli_resp(itm){
    var aux_=[]
    for(var i=0;i<this.responsables.length;i++){
      if(itm.id!=this.responsables[i].id){
        aux_.push(this.responsables[i])
      }
    }
    this.responsables=aux_
  }
  add_responsable(){
    this.bndResponsable=false;
    this.responsable.id=(this.responsables.length+1)
    this.responsables.push(this.responsable);
  }
  can_responsable(){
    this.bndResponsable=false;
  }
  bndResponsable=false;
  nvo_resp(){
    this.responsable={
      id:0,
      nombre:"",
      proveedor:"",
      paterno:"",
      materno:"",
      cargo:"",
      rs:"",
      rfc:"",
      correo:"",
      tel1:"",
      ext1:"",
      direccion:""    
    };
    
    this.bndResponsable=true;
  }
  responsable={
    id:0,
    nombre:"",
    proveedor:"",
    paterno:"",
    materno:"",
    cargo:"",
    rs:"",
    rfc:"",
    correo:"",
    tel1:"",
    ext1:"",
    direccion:""    
  };
  preventa={
    estatus:"P",
    id:0,
    nombre:"",
    paterno:"",
    materno:"",
    cargo:"",
    rs:"",
    rfc:"",
    correo:"",
    tel1:"",
    tel2:"",
    ext1:"",
    ext2:"",
    pais:"",
    estado:"",
    municipio:"",
    colonia:"",
    calle:"",
    cp:"",
    medio:""
  }
  ncliente(){   
    this.router.navigate(['/nuevocliente']);  
  }
  ncliente2_(){

  }
  preventas;
  loading;
  fecha;
  nombre;
  seguimiento(itm){
    console.log(itm);
    localStorage.setItem("id_cliente",itm.id); 
    localStorage.setItem("nom_cliente",itm.razonsocial); 
    localStorage.setItem("cliente",itm.id);
    localStorage.setItem("img_cliente",itm.img);
    localStorage.setItem("sufijo_cliente",itm.sufijo);
    localStorage.setItem("cliente_",JSON.stringify(itm));
    localStorage.setItem("modulos",itm.modulos); 
    this.router.navigate(['/iniciopg']);
  }
  clientes=[]
  prospectos=[]
  garoce=[]
  
  ls_prospectos(){
    this.loading=true;
    this.preventas=[];
    let postData={ 
      id_usuario:localStorage.getItem("usuario")
    };
    var sc="";
    //console.log(postData);
    sc="/api/get_prospecto"
    this.authService.service(sc,postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);   
          
          //console.log(res);
          for(var i=0;i<res.length;i++){
            if(res[i].estatus=='L'){
              this.prospectos.push(res[i]);
            }else if(res[i].estatus=='G'){
              this.garoce.push(res[i]);
            }      
          }
          
                   
          this.loading=false; 
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! ', '', 'error');
        });   
  }

  ls_cliente_preventa(){
    this.loading=true;
    this.preventas=[];
    let postData={ 
      id_usuario:localStorage.getItem("usuario")
    };
    var sc="";
    //console.log(postData);
    if(this.facturas==1){

      sc="/api/get_cliente"
    }else{
      sc="/api/get_cliente_by_usuario"
    }
    //console.log(sc);
    this.authService.service(sc,postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          this.clientes=data;
          this.preventas=data;
          //console.log(data);          
          this.loading=false; 
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! ', '', 'error');
        });   
  }

}
